import React, {Component} from 'react';
import FeaturedArticle from './FeaturedArticle';
import './FeaturedArticlesSection.less';
import {HomeRouteContext} from 'utils/context';

class FeaturedArticlesSection extends Component {
    render() {
        const {title, articles, ...rest} = this.props;
        if (articles && articles.length) {
            return (
                <section className="FeaturedArticlesSection hub-section">
                    <h2 className="FeaturedArticlesSection__title">{title}</h2>
                    <div className="FeaturedArticlesSection__wrapper">
                        <HomeRouteContext.Consumer>
                            {(homeRoute) =>
                                articles.map((article, idx) => (
                                    <FeaturedArticle
                                        homeRoute={homeRoute}
                                        key={idx}
                                        {...article}
                                        {...rest}
                                    />
                                ))
                            }
                        </HomeRouteContext.Consumer>
                    </div>
                </section>
            );
        }
        return null;
    }
}

export default FeaturedArticlesSection;
